const holder = {
  closeFiltersDropdown(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.outlet({
        selectedCategoryIds: holder.selectedCategoryIds,
        selectedUnitIds: holder.selectedUnitIds,
        selectedPriorityIds: holder.selectedPriorityIds,
        waitingOnParts: holder.waitingOnParts,
        noAccess: holder.noAccess,
        postErrorOrders: holder.postErrorOrders,
        activeOrders: holder.activeOrders,
        isCallback: holder.isCallback,
      });
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener('mousedown', holder.closeFiltersDropdown);
    }
  }
};

export default {
  'WorkOrdersFilters.Wrapper.HeaderWrapper': async ({
    isOpen,
    containerRef,
    selectedCategoryIds,
    selectedUnitIds,
    selectedPriorityIds,
    waitingOnParts,
    noAccess,
    isCallback,
    postErrorOrders,
    activeOrders
  }, outlet, internalStateSetter) => {
    if (isOpen) {
      await internalStateSetter('isOpen', false);
      document.removeEventListener('mousedown', holder.closeFiltersDropdown);
      return;
    }

    await internalStateSetter('isOpen', !isOpen);

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    holder.outlet = outlet;
    holder.selectedCategoryIds = selectedCategoryIds;
    holder.selectedUnitIds = selectedUnitIds;
    holder.selectedPriorityIds = selectedPriorityIds;
    holder.waitingOnParts = waitingOnParts;
    holder.noAccess = noAccess;
    holder.isCallback = isCallback;
    holder.postErrorOrders = postErrorOrders;
    holder.activeOrders = activeOrders;

    document.addEventListener('mousedown', holder.closeFiltersDropdown);
  },
  'WorkOrdersFilters.Wrapper.DropdownWrapper.BorderWrapper.NoAccess': ({ noAccess }, _, internalStateSetter) => {
    holder.noAccess = !noAccess;
    internalStateSetter({ noAccess: !noAccess });
  },
  'WorkOrdersFilters.Wrapper.DropdownWrapper.BorderWrapper.IsCallback': ({ isCallback }, _, internalStateSetter) => {
    holder.isCallback = !isCallback;
    internalStateSetter({ isCallback: !isCallback });
  },
  'WorkOrdersFilters.Wrapper.DropdownWrapper.BorderWrapper.PostError': ({ postErrorOrders }, _, internalStateSetter) => {
    holder.postErrorOrders = !postErrorOrders;
    internalStateSetter({ postErrorOrders: !postErrorOrders });
  },
  'WorkOrdersFilters.Wrapper.DropdownWrapper.BorderWrapper.ActiveOrders': ({ activeOrders }, _, internalStateSetter) => {
    holder.activeOrders = !activeOrders;
    internalStateSetter({ activeOrders: !activeOrders });
  },
  'WorkOrdersFilters.Wrapper.DropdownWrapper.BorderWrapper.WaitingOnParts': ({ waitingOnParts }, _, internalStateSetter) => {
    holder.waitingOnParts = !waitingOnParts;
    internalStateSetter({ waitingOnParts: !waitingOnParts });
  },
  'WorkOrdersFilters.Wrapper.DropdownWrapper.BorderWrapper.Category': ({ selectedIds }, _, internalStateSetter) => {
    holder.selectedCategoryIds = selectedIds;
    internalStateSetter({ selectedCategoryIds: selectedIds });
  },
  'WorkOrdersFilters.Wrapper.DropdownWrapper.BorderWrapper.Priority': ({ selectedIds }, _, internalStateSetter) => {
    holder.selectedPriorityIds = selectedIds;
    internalStateSetter({ selectedPriorityIds: selectedIds });
  },
  'WorkOrdersFilters.Wrapper.DropdownWrapper.BorderWrapper.Unit': ({ selectedIds }, _, internalStateSetter) => {
    holder.selectedUnitIds = selectedIds;
    internalStateSetter({ selectedUnitIds: selectedIds });
  },
  'WorkOrdersFilters.Wrapper.DropdownWrapper.BorderWrapper.ResetFilters': ({ }, _, internalStateSetter) => {
    holder.selectedCategoryIds = [];
    holder.selectedUnitIds = [];
    holder.selectedPriorityIds = [];
    holder.waitingOnParts = false;
    holder.noAccess = false;
    holder.isCallback = false;
    holder.postErrorOrders = false;
    holder.activeOrders = false;

    internalStateSetter({
      selectedCategoryIds: [],
      selectedUnitIds: [],
      selectedPriorityIds: [],
      waitingOnParts: false,
      noAccess: false,
      isCallback: false,
      postErrorOrders: false,
      activeOrders: false
    });
  }
};
